import { useState, useContext, useEffect } from "react";
import { Gift, X } from "lucide-react";
import { BackendContext } from '../Context/BackendContext';
import { ChromaIcon } from '../Components/Icons/ChromaIcon.tsx';

const rewards = [
  { day: 1, tokens: 500 },
  { day: 2, tokens: 500 },
  { day: 3, tokens: 500 },
  { day: 4, tokens: 500 },
  { day: 5, tokens: 1000 },
  { day: 6, tokens: 500 },
  { day: 7, tokens: 500 },
  { day: 8, tokens: 500 },
  { day: 9, tokens: 500 },
  { day: 10, tokens: 2000 },
];

const LogInRewardModal = ({isOpen, onClose, onClaim, day: dayProp }) => {
  const { userProfile } = useContext(BackendContext);

  const [day, setDay] = useState(null);
  const [reward, setReward] = useState(null);
  const [isClaiming, setIsClaiming] = useState(false);

  useEffect(() => { 
    if (dayProp !== null && dayProp !== undefined) {
      setDay(dayProp);
    }

    if (!userProfile) return;

    const now = new Date();
    const lastReset = getLastDailyReset(now);
    const lastClaimed = userProfile.lastDailyLogin ? new Date(userProfile.lastDailyLogin) : new Date(0);
    const loginDay = (userProfile.logInStreak || 0) + 1;

    let rewardForDay;
    if(loginDay === 1) {
      rewardForDay = 5000;
    }else {
      // Loop streak if exceeds 10 days (1–10)
      const rewardIndex = ((loginDay - 1) % rewards.length);
      console.log("rewardIndex:", rewardIndex);
      rewardForDay = rewards[rewardIndex];
    }

    if (lastClaimed < lastReset) {
      setDay(loginDay);
      setReward(rewardForDay);
      console.log("Daily reward available to claim. loningDay:", rewardForDay);
    } else {
      console.log("Daily reward already claimed today.");
      setDay(null);
      setReward(null);
    }

  }, [userProfile, dayProp]);

  const getLastDailyReset = (now = new Date()) => {
    const reset = new Date(now);
    reset.setHours(17, 0, 0, 0); // Reset to 5 PM today
    if (now < reset) {
      // If current time is before 5 PM, reset is yesterday 5 PM
      reset.setDate(reset.getDate() - 1);
    }
    return reset;
  }

  const handleClaim = async () => {
    setIsClaiming(true);
    try {
      await onClaim();
    } finally {
      setIsClaiming(false);
    }
  };

  if (!isOpen || day == null || !reward) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="w-full max-w-md bg-slate-900 rounded-lg shadow-lg overflow-hidden relative">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-slate-800 border-b border-slate-700">
          <div className="flex items-center gap-2 text-white font-semibold text-lg">
            <Gift className="w-5 h-5 text-yellow-400" />
            Daily Login Reward
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 text-white">
          <p className="text-sm text-gray-400 mb-4">
            Welcome back! You've logged in for <span className="text-white font-semibold">Day {day}</span>.
          </p>

          <div className="flex flex-col items-center bg-[#12172A] p-6 rounded-lg shadow">
            <div className="text-2xl font-bold flex items-center gap-2 text-cyan-400">
              <ChromaIcon size={32} variant="purple" />
              +{reward.tokens} Pixel Drops
            </div>
            <span className="text-xs text-gray-400 mt-2">Reward for logging in today</span>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 flex flex-col items-center gap-3 bg-slate-900 border-t border-slate-800">
          <button
            onClick={handleClaim}
            disabled={isClaiming}
            className={`px-12 py-2 border-2 rounded-2xl transition-colors
              ${isClaiming 
                ? 'bg-slate-700 text-gray-300 cursor-not-allowed border-gray-500' 
                : 'bg-slate-800 text-white border-zinc-200 hover:bg-indigo-700'}
            `}
          >
            {isClaiming ? "Claiming..." : "Claim Reward"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogInRewardModal;
